import { render, staticRenderFns } from "./TabAccessory.vue?vue&type=template&id=01d794ee&scoped=true&"
import script from "./TabAccessory.vue?vue&type=script&lang=ts&"
export * from "./TabAccessory.vue?vue&type=script&lang=ts&"
import style0 from "./TabAccessory.vue?vue&type=style&index=0&id=01d794ee&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01d794ee",
  null
  
)

export default component.exports